import type { FormField } from './dynamic-form';

function mapFieldsToDefaultValues<T>(fields: FormField[]) {
  return fields.reduce((acc, field) => {
    return {
      ...acc,
      [field.name]: 'defaultValue' in field ? field.defaultValue : null,
    };
  }, {} as T);
}

export function getDynamicFormDefaultValues<T>(fields: FormField[], value?: T): T {
  return value ?? mapFieldsToDefaultValues<T>(fields);
}
